/* Fenando — product page scripts
   Loaded with defer by snippets/fenando-config.liquid. Texts and links come from window.FEN. */
window.FEN = window.FEN || {};
if (!FEN.onDom) FEN.onDom = function (fn) { new MutationObserver(fn).observe(document.documentElement, { childList: true, subtree: true }); };

/* ==================== Buy now button ==================== */
try {
(function () {
  var TPL = document.getElementById('fenBuyNowTemplate');
  if (!TPL) return;

  // Only the main product form on a product page. Quick-add forms in
  // product cards (cart page, search, recommendations) are skipped.
  function form() {
    return document.querySelector(
      '.product-details form[action*="/cart/add"], ' +
      'product-form-component:not(.quick-add__product-form-component) form[action*="/cart/add"]'
    );
  }

  function place() {
    // One button per page, ever. Checked on the whole document so a
    // button placed next to (not inside) the form is never re-added.
    if (document.querySelector('[data-fen-buynow]')) return;

    var f = form();
    if (!f) return;

    var addBtn = f.querySelector('[name="add"], .add-to-cart-button, button[type="submit"]');
    if (!addBtn) return;

    // Insert right after the add-to-cart button's wrapper, but never
    // outside the form itself.
    var anchor = addBtn.closest('div');
    if (!anchor || !f.contains(anchor)) anchor = addBtn;

    var node = TPL.content.firstElementChild.cloneNode(true);
    anchor.parentNode.insertBefore(node, anchor.nextSibling);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-fen-buynow]') : null;
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    var f = form();
    if (!f) return;

    // Respect the engraving check — don't skip a required field
    var eng = document.querySelector('.fen-eng');
    if (eng && eng.style.display !== 'none' && !eng.classList.contains('is-off')) {
      var textEl = eng.querySelector('[data-fen-eng-text]');
      if (textEl && !textEl.value.trim()) {
        var err = eng.querySelector('[data-fen-eng-error]');
        textEl.classList.add('error');
        if (err) err.classList.add('show');
        textEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
        textEl.focus();
        return;
      }
    }

    btn.classList.add('is-busy');
    btn.disabled = true;

    // Send the product form to Shopify, then go straight to checkout.
    // A gift box chosen under "Maak er een cadeau van" goes in first.
    var data = new FormData(f);
    var box = window.fenGiftBox ? window.fenGiftBox.addSelected() : Promise.resolve();

    box
      .then(function () { return fetch('/cart/add.js', { method: 'POST', body: data }); })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        window.location.href = '/checkout';
      })
      .catch(function () {
        btn.classList.remove('is-busy');
        btn.disabled = false;
        // Fall back to the normal add-to-cart so the customer isn't stuck
        var addBtn = f.querySelector('[name="add"], .add-to-cart-button');
        if (addBtn) addBtn.click();
      });
  }, true);

  // Debounced: at most one check per frame, however many changes happen
  FEN.onDom(place);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', place);
  } else {
    place();
  }
  setTimeout(place, 400);
})();
} catch (e) { if (window.console) console.error('Fenando: Buy now button', e); }

/* ==================== Gift box option ==================== */
try {
(function () {
  var TPL = document.getElementById('fenGiftBoxTemplate');
  if (!TPL) return;

  var PRODUCT_TITLE = FEN.product ? FEN.product.title : '';
  var PRODUCT_HANDLE = FEN.product ? FEN.product.handle : '';
  var LABEL_FOR = FEN.t.forLabel;
  var root = null;

  function form() {
    return document.querySelector(
      '.product-details form[action*="/cart/add"], ' +
      'product-form-component:not(.quick-add__product-form-component) form[action*="/cart/add"]'
    );
  }

  // Above the buttons, outside the form (so nothing extra is sent with the product)
  function place() {
    if (document.querySelector('[data-fen-gb]')) return;
    var f = form();
    if (!f) return;
    var anchor = f.closest('.buy-buttons-block') || f.closest('product-form-component') || f;
    root = TPL.content.firstElementChild.cloneNode(true);
    anchor.parentNode.insertBefore(root, anchor);

    var on = root.querySelector('[data-fen-gb-on]');
    var panel = root.querySelector('[data-fen-gb-panel]');
    on.addEventListener('change', function () { panel.hidden = !on.checked; });
  }

  function selected() {
    var r = root || document.querySelector('[data-fen-gb]');
    if (!r) return null;
    var on = r.querySelector('[data-fen-gb-on]');
    if (!on || !on.checked) return null;
    var pick = r.querySelector('input[name="fen-gb-box"]:checked');
    return pick ? Number(pick.value) : null;
  }

  // Adds the chosen box (once per product) and the card text. Never rejects:
  // if something goes wrong the product is still bought.
  function addSelected() {
    var id = selected();
    if (!id) return Promise.resolve();
    var msgEl = document.getElementById('fenGbMsg');
    var msg = msgEl ? msgEl.value.trim() : '';

    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var already = cart.items.some(function (it) {
          return it.variant_id === id && it.properties && it.properties._fen_voor === PRODUCT_HANDLE;
        });
        if (already) return;
        var props = { _fen_voor: PRODUCT_HANDLE };
        props[LABEL_FOR] = PRODUCT_TITLE;
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: 1, properties: props }] })
        });
      })
      .then(function () {
        if (!msg) return;
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { 'Cadeaubericht': msg } })
        });
      })
      // Let the cart icon and the cart know about the box before the product follows
      .then(function () { return fetch('/cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: cart, sourceId: 'fenando-giftbox', data: { itemCount: cart.item_count, source: 'fenando-giftbox' } }
        }));
      })
      .catch(function () {});
  }

  window.fenGiftBox = { selected: selected, addSelected: addSelected };

  // "Aan winkelwagen toevoegen": put the box in first, then let the theme add
  // the product as usual (so the cart drawer opens with both in it).
  // On window (not document): runs before any listener the theme puts on
  // document, so the product is never added twice
  var passing = false;
  window.addEventListener('submit', function (e) {
    var f = form();
    if (!f || e.target !== f || passing || !selected()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var submitter = e.submitter;
    addSelected().then(function () {
      passing = true;
      try {
        if (submitter && f.contains(submitter)) f.requestSubmit(submitter);
        else f.requestSubmit();
      } finally {
        passing = false;
      }
    });
  }, true);

  FEN.onDom(place);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', place);
  else place();
})();
} catch (e) { if (window.console) console.error('Fenando: Gift box option', e); }

/* ==================== Product page layout 1 ==================== */
try {
(function () {
  var TPL = document.getElementById('fenPdpCatTemplate');
  if (!TPL) return;

  function place() {
    var det = document.querySelector('.product-information .product-details');
    if (!det || det.querySelector('.fen-pdp-cat')) return;

    var h1 = det.querySelector('h1');
    if (!h1) return;

    var node = TPL.content.firstElementChild.cloneNode(true);
    var row = h1.closest('.group-block');

    // Normal case: the small group that holds just the title and the price
    if (row && det.contains(row) && row.querySelector('product-price') && !row.querySelector('variant-picker, form')) {
      row.parentNode.insertBefore(node, row);
    } else {
      // Someone moved the blocks around: put it straight above the title
      node.classList.add('is-inline');
      var block = h1.closest('.text-block') || h1;
      block.parentNode.insertBefore(node, block);
    }
  }

  FEN.onDom(place);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', place);
  } else {
    place();
  }
})();
} catch (e) { if (window.console) console.error('Fenando: Product page layout 1', e); }

/* ==================== Product page layout ==================== */
try {
(function () {
  var fine = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');
  var SCALE = 2.2;
  var active = null, img = null;

  function find(e) {
    var c = e.target && e.target.closest ? e.target.closest('.product-information__media .product-media-container--image') : null;
    if (!c || c.closest('zoom-dialog, dialog')) return null;
    return c;
  }

  function start(c) {
    var i = c.querySelector('img');
    if (!i) return;
    active = c;
    img = i;
    // Ask the browser for a bigger version from the srcset, so the zoom stays sharp
    if (!i.hasAttribute('data-fen-zoom')) {
      i.setAttribute('data-fen-zoom', '');
      var w = Math.round(c.getBoundingClientRect().width * SCALE * (window.devicePixelRatio || 1));
      i.setAttribute('sizes', Math.min(w, 3000) + 'px');
    }
    c.classList.add('fen-zooming');
    i.style.transform = 'scale(' + SCALE + ')';
  }

  function stop() {
    if (img) { img.style.transform = ''; }
    if (active) active.classList.remove('fen-zooming');
    active = null;
    img = null;
  }

  function move(e) {
    if (!fine.matches) return;
    var c = find(e);
    if (c !== active) { stop(); if (c) start(c); }
    if (!img) return;
    var r = active.getBoundingClientRect();
    var x = Math.max(0, Math.min(100, (e.clientX - r.left) / r.width * 100));
    var y = Math.max(0, Math.min(100, (e.clientY - r.top) / r.height * 100));
    img.style.transformOrigin = x + '% ' + y + '%';
  }

  document.addEventListener('mousemove', move, { passive: true });
  document.addEventListener('mouseleave', stop);
  window.addEventListener('blur', stop);
  // Opening the full-screen zoom or swiping resets the hover zoom
  document.addEventListener('click', function (e) { if (find(e)) stop(); }, true);
})();
} catch (e) { if (window.console) console.error('Fenando: Product page layout', e); }

/* ==================== Product text column follows the header (desktop) ==================== */
try {
(function () {
  if (window.__fenPdpScroll) return;
  window.__fenPdpScroll = true;

  var desktop = window.matchMedia('(min-width: 750px)');
  var gap = null;        // space between header and text at the top of the page
  var until = 0;
  var running = false;

  function getHeader() {
    return document.querySelector('header-component') ||
           document.querySelector('#header-group header, .header-section header, header');
  }
  function getDetails() {
    return document.querySelector('.product-details.sticky-content--desktop');
  }

  // Bottom edge of the header as visible on screen (0 when it is hidden)
  function headerBottom() {
    var h = getHeader();
    if (!h) return 0;
    var r = h.getBoundingClientRect();
    return Math.max(0, Math.min(r.bottom, window.innerHeight / 2));
  }

  function update() {
    var d = getDetails();
    if (!d || !desktop.matches) {
      document.documentElement.style.removeProperty('--fen-pdp-top');
      return;
    }
    var hb = headerBottom();
    if (gap === null) {
      // Measure once at the top of the page so the text starts exactly
      // where it already is and does not move when you begin scrolling.
      gap = window.scrollY < 5
        ? Math.min(48, Math.max(0, d.getBoundingClientRect().top - hb))
        : 16;
    }
    document.documentElement.style.setProperty('--fen-pdp-top', Math.round(hb + gap) + 'px');
  }

  // Keep updating for half a second after each scroll, so we also follow
  // the header's own slide-in / slide-out animation frame by frame.
  function loop() {
    update();
    if (performance.now() < until) {
      requestAnimationFrame(loop);
    } else {
      running = false;
    }
  }
  function kick() {
    until = performance.now() + 500;
    if (!running) {
      running = true;
      requestAnimationFrame(loop);
    }
  }

  window.addEventListener('scroll', kick, { passive: true });
  window.addEventListener('resize', function () { gap = null; kick(); });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', kick);
  } else {
    kick();
  }
})();
} catch (e) { if (window.console) console.error('Fenando: Product text column follows the header (desktop)', e); }
